import { render, staticRenderFns } from "./ReportWidget.vue?vue&type=template&id=2157b5aa"
import script from "./ReportWidget.vue?vue&type=script&lang=js"
export * from "./ReportWidget.vue?vue&type=script&lang=js"
import style0 from "./ReportWidget.vue?vue&type=style&index=0&id=2157b5aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports